module.exports = __webpack_public_path__ + "static/media/homeitem1.2261cb7c.png";